import { useWebViewContentReady } from 'components/web_view/hooks'

export const StatsWebViewHooks = () => {
  useWebViewContentReady()

  return <></>
}
